import React from 'react'
import { connect } from 'react-redux'

import { selectActualPartnerName, selectPartner } from 'containers/App/selectors'
import { selectGroupSettingsName } from 'containers/Settings/selectors'

import LargeBanner from 'components/elements/LargeBanner'
import { GroupSettingsConnection } from 'components/lib/DesignSystem/Icons'

function GroupSettingsBanner({
  isGroupSettingsFlow,

  partner,
  partnerName,
  groupSettingsNameByPartner,
}) {
  if (isGroupSettingsFlow || !groupSettingsNameByPartner) return ''

  const text = partner
    ? `These settings are inherited from ${groupSettingsNameByPartner} group settings.`
    : `These settings are managed by ${partnerName}.`

  return (
    <LargeBanner
      id="settings_GroupSettings_banner"
      type="primary"
      Icon={GroupSettingsConnection}
      text={text}
      subText={!partner && `Contact ${partnerName} for details.`}
    />
  )
}

const render = connect((state) => ({
  partner: selectPartner(state),
  partnerName: selectActualPartnerName(state),
  groupSettingsNameByPartner: selectGroupSettingsName(state),
}))(GroupSettingsBanner)

export default render
